import { getApiClient } from './apiClient'

interface PendoDelegate {
  jobtitle: string
  state: { state: string; country: string }
}

interface PendoCompany {
  id: string
  name: string
  email: string
  website: string
  state: { state: string; country: string }
  sector: { sector: string; subSector: string }
  areas: string[]
}

export const fn = async (): Promise<{ data: { delegate: PendoDelegate; company: PendoCompany } }> => {
  const response = await getApiClient().get('participants/pendo')

  return response.data
}

export default fn
